var flashSale = "https://shopfront-cdn.tekoapis.com/static/b0b6d87219b43554.svg";

export { flashSale as default };
